// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"3c3527a2b617c346c8f3","293":"4d9d886a21dd18c7c68b","452":"acf513f4b16bcb0a4e07"}[chunkId] + ".js";
};